<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ headOfficeLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field
              label="Name"
              v-model="ho.name"
              @input="$v.ho.name.$touch()"
              @blur="$v.ho.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              label="Code"
              v-model="ho.code"
              @input="$v.ho.code.$touch()"
              @blur="$v.ho.code.$touch()"
              :error-messages="codeErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              label="External Code"
              v-model="ho.externalCode"
              :error-messages="codeErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field
              label="Email"
              v-model="ho.email"
              @input="$v.ho.email.$touch()"
              @blur="$v.ho.email.$touch()"
              :error-messages="emailErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              label="Telephone"
              v-model="ho.telephone"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm6>
            <v-textarea
              label="Address"
              v-model="ho.address"
              :outlined="outlinedInputs"
            ></v-textarea>
          </v-flex>
          <v-flex sm6>
            <v-textarea
              label="Notes"
              v-model="ho.notes"
              :outlined="outlinedInputs"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm6>
            <v-switch
              label="Not In Use"
              v-model="ho.notInUse"
              @change="onNotInUseChange"
              primary
              hide-details
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  HEAD_OFFICE_UPDATE_MUTATION,
  HEAD_OFFICE_CREATE_MUTATION,
} from "../../../../constants/graphql";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "HeadOfficeEditor",

  props: {
    headOffice: {
      type: Object,
      default: () => ({}),
    },

    doSaveHeadOffice: {
      type: Boolean,
      default: false,
    },

    headOfficeEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ho: { ...this.headOffice },
      debug: false,
    };
  },

  methods: {
    onNotInUseChange(v) {
      if (this.ho.notInUse) {
        if (
          !confirm(
            "Not in use flag has been selected. This action will remove this head office from existing suppliers. Do you wish to continue?"
          )
        ) {
          setTimeout(
            function (t) {
              t.ho.notInUse = false;
            },
            0,
            this
          );
        }
      }
    },
    saveHeadOffice() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? HEAD_OFFICE_UPDATE_MUTATION
            : HEAD_OFFICE_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.ho,
            },
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    headOfficeLabel() {
      return this.headOffice.id != null
        ? this.headOffice.name
        : "New Head Office";
    },
    context() {
      return this.headOffice.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.ho.name.$dirty) {
        return errors;
      }
      if (!this.$v.ho.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    codeErrors() {
      let errors = [];
      if (!this.$v.ho.code.$dirty) {
        return errors;
      }
      if (!this.$v.ho.code.required) {
        errors.push("Code is required.");
      }
      return errors;
    },
    emailErrors() {
      let errors = [];
      if (!this.$v.ho.email.$dirty) {
        return errors;
      }
      if (!this.$v.ho.email.required) {
        errors.push("Email is required.");
      }
      if (!this.$v.ho.email.email) {
        errors.push("Input must be an email.");
      }
      return errors;
    },
  },

  watch: {
    headOffice(data) {
      let headOffice = { ...data };
      delete headOffice.__typename;
      this.ho = headOffice;
    },
    headOfficeEditorDialog(value) {
      if (!value) {
        this.ho = {};
        this.$v.$reset();
      }
    },
    doSaveHeadOffice(value) {
      if (value) {
        this.saveHeadOffice();
      }
    },
  },
  validations: {
    ho: {
      name: { required },
      email: { required, email },
      code: { required },
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/department-types/HeadOfficeEditor.vue